const HANDLER_NAME = 'caraEvent';

const getCaraMessageHandler = () => {
  return window.webkit?.messageHandlers?.[HANDLER_NAME] ?? null;
};

export const isCaraBridgeAvailable = () => {
  return Boolean(getCaraMessageHandler());
};

export const postCaraEvent = (payload) => {
  const handler = getCaraMessageHandler();

  if (!handler) {
    console.warn('[CaraBridge] Native iOS bridge is not available for payload:', payload);
    return false;
  }

  try {
    handler.postMessage(payload);
    console.log('[CaraBridge] Sent payload to native iOS:', payload);
    return true;
  } catch (error) {
    console.error('[CaraBridge] Failed to send payload to native iOS:', payload, error);
    return false;
  }
};

export const sendCaraStart = () => {
  return postCaraEvent({ event: 'start' });
};

export const sendCaraStop = () => {
  return postCaraEvent({ event: 'stop' });
};

export const sendCaraQuit = () => {
  return postCaraEvent({ event: 'quit' });
};
